import React from "react";

export function CampaignReport() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-medium text-gray-800">Report</h2>
        <p className="text-sm text-muted-foreground">
          Campaign report content will be added here.
        </p>
      </div>
    </div>
  );
}
